/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ApiAppExceptionTestBrokerExceptionGet400Response } from '../model/api-app-exception-test-broker-exception-get400-response.model';
// @ts-ignore
import { GoUserAnonymousOnboardingSettingsInfoDto } from '../model/go-user-anonymous-onboarding-settings-info-dto.model';
// @ts-ignore
import { GoUserAnonymousOnboardingSettingsUpdateDto } from '../model/go-user-anonymous-onboarding-settings-update-dto.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class GoUserAnonymousOnboardingSettingsApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint get /api/go-user/{goUserId}/settings/anonymous-onboarding
     * @param goUserId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiGoUserGoUserIdSettingsAnonymousOnboardingGet(goUserId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GoUserAnonymousOnboardingSettingsInfoDto>;
    public apiGoUserGoUserIdSettingsAnonymousOnboardingGet(goUserId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GoUserAnonymousOnboardingSettingsInfoDto>>;
    public apiGoUserGoUserIdSettingsAnonymousOnboardingGet(goUserId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GoUserAnonymousOnboardingSettingsInfoDto>>;
    public apiGoUserGoUserIdSettingsAnonymousOnboardingGet(goUserId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (goUserId === null || goUserId === undefined) {
            throw new Error('Required parameter goUserId was null or undefined when calling apiGoUserGoUserIdSettingsAnonymousOnboardingGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/go-user/${this.configuration.encodeParam({name: "goUserId", value: goUserId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/settings/anonymous-onboarding`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GoUserAnonymousOnboardingSettingsInfoDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint put /api/go-user/{goUserId}/settings/anonymous-onboarding
     * @param goUserId 
     * @param goUserAnonymousOnboardingSettingsUpdateDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiGoUserGoUserIdSettingsAnonymousOnboardingPut(goUserId: string, goUserAnonymousOnboardingSettingsUpdateDto?: GoUserAnonymousOnboardingSettingsUpdateDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GoUserAnonymousOnboardingSettingsInfoDto>;
    public apiGoUserGoUserIdSettingsAnonymousOnboardingPut(goUserId: string, goUserAnonymousOnboardingSettingsUpdateDto?: GoUserAnonymousOnboardingSettingsUpdateDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GoUserAnonymousOnboardingSettingsInfoDto>>;
    public apiGoUserGoUserIdSettingsAnonymousOnboardingPut(goUserId: string, goUserAnonymousOnboardingSettingsUpdateDto?: GoUserAnonymousOnboardingSettingsUpdateDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GoUserAnonymousOnboardingSettingsInfoDto>>;
    public apiGoUserGoUserIdSettingsAnonymousOnboardingPut(goUserId: string, goUserAnonymousOnboardingSettingsUpdateDto?: GoUserAnonymousOnboardingSettingsUpdateDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (goUserId === null || goUserId === undefined) {
            throw new Error('Required parameter goUserId was null or undefined when calling apiGoUserGoUserIdSettingsAnonymousOnboardingPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/go-user/${this.configuration.encodeParam({name: "goUserId", value: goUserId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/settings/anonymous-onboarding`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GoUserAnonymousOnboardingSettingsInfoDto>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: goUserAnonymousOnboardingSettingsUpdateDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
